module.exports = __webpack_public_path__ + "static/img/kf_cloud_00005.6f47587.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00005.jpg
// module id = 176
// module chunks = 1